import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NavItem from './NavItem';

function SettingsNavItem(props) {
  const {
    width,
    iconwidth,
    iconheight,
    marginright,
    boxshadow,
    colorhover,
    backgroundcolor,
    backgroundcolorhover,
    color,
  } = props;
  const { t } = useTranslation();
  return (
    <NavItem
      aria-label="settings"
      to="/settings"
      width={width}
      iconwidth={iconwidth}
      iconheight={iconheight}
      color={color}
      marginright={marginright}
      boxshadow={boxshadow}
      backgroundcolor={backgroundcolor}
      backgroundcolorhover={backgroundcolorhover}
      colorhover={colorhover}
      title={t('Settings')}
    >
      <SettingsOutlinedIcon color="primary" />
    </NavItem>
  );
}

SettingsNavItem.propTypes = {
  width: PropTypes.number,
  iconwidth: PropTypes.number,
  iconheight: PropTypes.number,
  boxshadow: PropTypes.string,
  backgroundcolorhover: PropTypes.string,
  colorhover: PropTypes.string,
  backgroundcolor: PropTypes.string,
  marginright: PropTypes.number,
  color: PropTypes.string,
};

SettingsNavItem.defaultProps = {
  width: 0,
  iconwidth: 16,
  iconheight: 16,
  backgroundcolor: '',
  backgroundcolorhover: '#fff',
  colorhover: '',
  boxshadow: '',
  marginright: 10,
  color: '',
};

export default SettingsNavItem;
